module.exports = __webpack_public_path__ + "70a35c19c1a4a881ae6901b53b40b243.pdf";